import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    type: { type: String, default: "html" }
  }

  connect() {
    // Add cursor pointer style
    this.element.style.cursor = "pointer"
  }

  click(event) {
    // Don't intercept clicks inside interactive elements
    if (event.target.closest('details, summary, a, button, input, textarea, select')) return

    event.preventDefault()
    
    const url = this.urlValue || this.element.getAttribute("data-clickable-link-url-param")
    const type = this.typeValue || this.element.getAttribute("data-clickable-link-type-param") || "html"
    
    if (url) {
      if (type === "html") {
        // Navigate to the URL
        Turbo.visit(url)
      } else {
        // Handle turbo-stream response
        this.handleTurboStream(url)
      }
    }
  }

  async handleTurboStream(url) {
    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error("Error loading turbo stream:", error)
    }
  }
}